<div
  class="surface-lowest flex cursor-pointer flex-col items-center justify-center rounded-2xl p-2 drop-shadow-md transition-transform duration-200"
  [class]="
    disabled() || !text() ? '!cursor-not-allowed opacity-50' : 'hover:scale-115'
  "
>
  @if (isLoading()) {
    <div class="loading-spinner"></div>
  } @else {
    <mat-icon
      [matMenuTriggerFor]="disabled() || !text() ? null : promptMenu"
      class="bg-gradient-to-br from-green-300 to-green-500 bg-clip-text text-transparent"
      [class]="disabled() ? 'cursor-not-allowed' : ''"
    >
      auto_awesome
    </mat-icon>
  }
  <mat-icon
    class="transition-all duration-200"
    [class]="disabled() ? 'cursor-not-allowed' : ''"
    [style]="
      undoStack().length && !isLoading()
        ? 'height: auto; margin-top: .5rem'
        : 'height: 0'
    "
    (click)="undoClick()"
  >
    undo
  </mat-icon>
</div>

<mat-menu #promptMenu="matMenu" class="ai-prompt-menu">
  @for (prompt of promptList(); track prompt.id) {
    <button
      mat-menu-item
      (click)="onPromptClick(prompt)"
      [disabled]="isLoading() || disabled()"
      class="hover:bg-primary-container flex items-center gap-2"
    >
      <span class="flex-1 truncate">{{ prompt.description }}</span>
    </button>
  }
</mat-menu>
